import * as Config from '../../../config';
import React from 'react';
import PropTypes from 'prop-types';
import './CoverflowBase.css'

import CoverFlowContainer from './CoverFlowContainer';
import Breadcrumb from './Breadcrumb';
import ContainerTopActions from './ContainerTopActions';
import ContainerBottomActions from './ContainerBottomActions';
// import ShortcutsWrapper from './ShortcutsWrapper'; // DEPRECATED

import useCoverFlow from './hooks/useCoverFlow';

function CoverFlowWrapper({ maxWidth, height, isFullHeight, onFullScreen, isFullScreen = false }) {
  const {
    uidAutomix, isAutomix, playlists,
    bpmAutomix, autoBpmAutomix, isRandom,
    active, isSettingHideAutomix,
    toggle, autoBPM, setBPM, callPlay, callPause, prepareNext, preparePrevious, toggleRandom,
    clickItem,
  } = useCoverFlow(height, onFullScreen);

  const customHeight = height; // (height + (isAutomix ? 70 : 0)); //TODO HANDLE COMPACT MODE
  let coverFlowStyle = (isFullHeight) ? { width: maxWidth - Config.SIDE_WIDTH, height: customHeight, marginLeft: 0 } : { width: maxWidth, height: customHeight, marginLeft: 0 }

  return (!isSettingHideAutomix) ? (
    <div className={`coverflow ${isAutomix && height > 150 ? `on` : `off`}`} style={coverFlowStyle} >
      {(isAutomix && playlists.tracks.length > 0 && height > 150) && (
        <>
          <ContainerTopActions 
            isFullScreen={isFullScreen}
            onFullScreen={onFullScreen}
            toggle={toggle}
          />
          <CoverFlowContainer playlists={playlists} active={active} clickItem={clickItem} coverFlowStyle={coverFlowStyle} />
          <Breadcrumb active={playlists.active} tracks={playlists.tracks}  width={(isFullHeight) ? maxWidth - Config.SIDE_WIDTH : maxWidth} />
          <ContainerBottomActions
            title={uidAutomix}
            currentID={(playlists.tracks && playlists.tracks[playlists.active]) ? playlists.tracks[playlists.active].id : null}
            to={playlists.tracks ? playlists.from : null}
            bpmAutomix={bpmAutomix}
            autoBpmAutomix={autoBpmAutomix} 
            isRandom={isRandom}
            autoBPM={autoBPM}
            setBPM={setBPM}
            callPlay={callPlay}
            callPause={callPause}
            prepareNext={prepareNext}
            preparePrevious={preparePrevious}
            toggleRandom={toggleRandom}
            isLast={playlists.active + 1 >= playlists.tracks.length}
          />
          {/* <ShortcutsWrapper onRandom={toggleRandom} onNext={prepareNext(false)} onPrevious={preparePrevious} /> */}
        </>
      )}
    </div>
  ) : <div className={`hide-coverflow`} style={coverFlowStyle} />
}

CoverFlowWrapper.propTypes = {
  maxWidth: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  isFullHeight: PropTypes.bool.isRequired,
  onFullScreen: PropTypes.func,
  isFullScreen: PropTypes.bool,
}

export default CoverFlowWrapper;
